import isEqual from 'lodash/isEqual';
import {
  Day,
  Maybe,
  PlatformScheduling,
  PostChannel,
  PostingHoursDay,
  SocialMediaScheduling,
} from '@/__generated__/graphql';

export const transformScheduleArray = (obj?: PostingHoursDay | null) => {
  if (!obj) {
    return null;
  }
  return Object.entries(
    Object.fromEntries(
      Object.entries(obj).filter(([key]) => key !== '__typename')
    )
  )
    .map(([day, hour]) => {
      return { day, hour };
    })
    .sort((a, b) => {
      const daysOrder = [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
      ];
      return daysOrder.indexOf(a.day) - daysOrder.indexOf(b.day);
    });
};

export const getPostWeekDays = (
  channel: PostChannel,
  socialMediaPostingOverrides?: SocialMediaScheduling | null
) => {
  if (socialMediaPostingOverrides) {
    const days =
      socialMediaPostingOverrides[
        channel as Exclude<PostChannel, PostChannel.Unspecified>
      ] &&
      Object.keys(
        socialMediaPostingOverrides[
          channel as Exclude<PostChannel, PostChannel.Unspecified>
        ]?.Days || {}
      ).filter((key) => key !== '__typename');

    return days as Day[];
  }
};

export const isDefaultPostingTime = (
  channel: Exclude<PostChannel, PostChannel.Unspecified>,
  day: string,
  socialMediaPostingTimes: SocialMediaScheduling,
  socialMediaPostingDefaults?: SocialMediaScheduling | null
) => {
  if (socialMediaPostingDefaults && socialMediaPostingTimes) {
    const defaultDays = socialMediaPostingDefaults[channel]?.Days;
    const postingDays = socialMediaPostingTimes[channel]?.Days;

    if (
      defaultDays &&
      postingDays &&
      defaultDays[day as keyof PostingHoursDay] ===
        postingDays[day as keyof PostingHoursDay]
    ) {
      return true;
    }

    return false;
  }
};

export const isGeneralDefaultPostingTime = (
  channel: Exclude<PostChannel, PostChannel.Unspecified>,
  postingTimes: SocialMediaScheduling | null | undefined,
  socialMediaPostingTimes: Maybe<SocialMediaScheduling> | undefined
) => {
  if (postingTimes && socialMediaPostingTimes) {
    const generalDefault =
      socialMediaPostingTimes[channel]?.GeneralDefault?.EventTime;
    const generalDefaultActual =
      postingTimes[channel]?.GeneralDefault?.EventTime;

    if (generalDefault === generalDefaultActual) {
      return true;
    }

    return false;
  }
};

export const isResetButtonDisabled = (
  channel: Exclude<PostChannel, PostChannel.Unspecified>,
  socialMediaPostingTimes?: SocialMediaScheduling | null,
  socialMediaPostingDefaults?: SocialMediaScheduling
) => {
  if (
    isEqual(
      socialMediaPostingDefaults && socialMediaPostingDefaults[channel],
      socialMediaPostingTimes && socialMediaPostingTimes[channel]
    )
  ) {
    return true;
  }

  return false;
};

export function transformScheduling(
  obj1?: PlatformScheduling | null,
  obj2?: PlatformScheduling | null,
  channel?: PostChannel,
  generalDefault?: string
) {
  if (!obj1 || !obj2) {
    return null;
  }
  const result = [];

  for (const day in obj1.Days) {
    if (
      obj2.Days &&
      obj1.Days[day as keyof PostingHoursDay] !==
        obj2.Days[day as keyof PostingHoursDay]
    ) {
      result.push({
        platform: channel,
        days: day,
        time: obj1.Days[day as keyof PostingHoursDay],
      });
    }
  }

  result.push({
    platform: channel,
    generalDefault: {
      eventTime: true,
    },
    days: [],
    time: generalDefault,
  });

  return result;
}
